import { Component, OnDestroy, OnInit } from '@angular/core';
import { ErrorMsgService } from './error-msg.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['./error-msg.component.scss']
})
export class ErrorMsgComponent implements OnInit , OnDestroy {

  msg = "";
  reloadOnCloseFlag = false;
  showTextArray = false;
  textArray = [];
  multibleLines = false;
  multibleLinesConfig:any = {};
  constructor(private errorMsgService: ErrorMsgService,
    private router: Router,
    ) {
    this.errorMsgService.getMessage().subscribe(res => {
      if (res != null) {
        this.msg = res;
        // Only show modal if multiple lines are not being shown
        if (!this.multibleLines) {
          $("#error-msg-popup").modal('show');
        }
      }
    });
    this.errorMsgService.getReloadOnCloase().subscribe(res =>{
      this.reloadOnCloseFlag = res == true ? true : false;
    });
    this.errorMsgService.getTextArray().subscribe((res: any) =>{
      if(res){
        this.showTextArray = res?.showTextArray;
        this.textArray = res?.textArray;
      }
    })

    this.errorMsgService.getMultibleLinesConfig().subscribe((res: any) =>{
      if(res){
        this.msg = '';
        this.multibleLines = res?.multibleLines;
        this.multibleLinesConfig = res;
        if(this.multibleLines){
          $("#error-msg-popup").modal('show');
        }
      }
    })

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.errorMsgService.setTextArray({
      showTextArray: false,
      textArray: []
    })
    this.errorMsgService.setMultibleLinesConfig({
      multibleLines: false,
      lineConfig: []
    });
    this.multibleLines = false;
  }

  reloadOnClose(){
    if(this.reloadOnCloseFlag == true) {
      let currentUrl = this.router.url;
      this.errorMsgService.setReloadOnClose(false);
      this.router.navigateByUrl(`/`, { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
    this.errorMsgService.setMultibleLinesConfig({
      multibleLines: false,
      lineConfig: []
    });
    this.multibleLines = false;
  }
}
